import Vue from 'vue';
import LogRocket from 'logrocket';
import '@formatjs/intl-relativetimeformat/polyfill';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { i18n } from '@/i18n';
import '@/assets/styles/tailwind.pcss';
import '@/helpers/firebase/services';
import './helpers/fontAwesomeIcons/library';
import router from './router';
import App from './App';


Vue.config.productionTip = false;

// Vue Global components
Vue.component('IconFA', FontAwesomeIcon);

if (process.env.NODE_ENV !== 'development') {
  LogRocket.init(`3iqapi/autodrop-${process.env.VUE_APP_MODE}`, {
    release: process.env.VUE_APP_VERSION,
  });
}

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
